import { render, staticRenderFns } from "./SalesDiscountComps.vue?vue&type=template&id=52dd2374&"
import script from "./SalesDiscountComps.vue?vue&type=script&lang=js&"
export * from "./SalesDiscountComps.vue?vue&type=script&lang=js&"
import style0 from "./SalesDiscountComps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports